import { render, staticRenderFns } from "./FlipTracker.vue?vue&type=template&id=987c39cc"
import script from "./FlipTracker.vue?vue&type=script&lang=js"
export * from "./FlipTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports